import React, { useEffect, useState } from 'react';
import Information from './components/Information';
import ProductPrice from './components/ProductPrice';
import AdditionalInformation from './components/AdditionalInformation';
import { Button, Col, Form, message, Row } from 'antd';
import * as CommonService from '../../../services/CommonService';
import { BRAND_ENDPOINT, PRODUCT_ENDPOINT, PRODUCT_TYPE_ENDPOINT, WARRANTY_POLICY } from '../../../services/endpoint';
import { useHistory, useParams } from 'react-router-dom';

const ProductCreate = (props) => {

	const { id } = useParams();

	const history = useHistory();

	const [productType, setProductType] = useState([]);
	const [brands, setBrands] = useState([]);
	const [warranties, setWarranties] = useState([]);
	const [imeiList, setImeiList] = useState([]);
	const [isNormal, setIsNormal] = React.useState(false);
	const [guarantee, setGuarantee] = React.useState(false);
	const [status, setStatus] = React.useState(false);


	useEffect(() => {
		const init = async () => {
			const apiList = [
				await CommonService.get(PRODUCT_TYPE_ENDPOINT, {}),
				await CommonService.get(BRAND_ENDPOINT, {}),
				await CommonService.get(WARRANTY_POLICY, {}),
				await CommonService.findById(PRODUCT_ENDPOINT, id)
			];
			const resp = Promise.all(apiList);
			const [productTypeRes, brandRes, warrantyRes, productRes] = await resp;
			setBrands(brandRes.data || []);
			setProductType(productTypeRes.data || []);
			setWarranties(warrantyRes.data || []);
			initForm(productRes.data);
			window.setLoading(false);
		};
		window.setLoading(true);
		init();
	}, []);

	const initForm = (data) => {
		setIsNormal(data.isNormal);
		setGuarantee(data.warrantyPolicyId !== null);
		setStatus(data.status);
		const initData = {
			...data,
			brandId: data.brandResponse?.id || undefined,
			productTypeId: data.productTypeResponse?.id || undefined,
			weight: data.weight?.split(' ')[0] || undefined,
			weightUnit: data.weight?.split(' ')[1] || undefined
		};
		setImeiList(data.imeiResponseList?.map(el => el.imei) || []);
		props.form.setFieldsValue(initData);
	};


	const handleSubmit = (e) => {
		e.preventDefault();
		props.form.validateFields((err, values) => {
			if (!err) {
				const body = {
					...values,
					weight: `${values.weight} ${values.weightUnit}`,
					imei: imeiList,
					isNormal
				};
				removeKey(body)
				window.setLoading(true);
				CommonService.update(PRODUCT_ENDPOINT, id, body).then(() => {
					message.success('Cập nhật thành công');
					back();
				}).catch(err => {
					message.error(err?.data?.message);
				}).finally(() => {
					window.setLoading(false);
				});
			}
		});
	};

	const removeKey = (body) => {
		delete body.weightUnit;
		delete body.imei;
		delete body.isNormal;
		delete body.name;
		delete body.code;
	}

	const back = () => {
		history.push('/product');
	};

	return (
		<div id={'product-create-page'}>
			<Form layout={'vertical'} className={'pd-lr-200'}>
				<Row gutter={12}>
					<Col sm={16}>
						<Row>
							<Information form={props.form}
													 imeiList={imeiList}
													 setImeiList={setImeiList}
													 isNormalProduct={isNormal}
													 setIsNormalProduct={setIsNormal}
							/>
						</Row>
						<br />
						<Row>
							<ProductPrice form={props.form} />
						</Row>
					</Col>
					<Col sm={8}>
						<AdditionalInformation form={props.form}
																	 productType={productType}
																	 brands={brands}
																	 warranties={warranties}
																	 setWarranties={setWarranties}
																	 guarantee={guarantee}
																	 setGuarantee={setGuarantee}
																	 status={status}
																	 setStatus={setStatus}
																	 setProductType={setProductType}
																	 setBrands={setBrands}
						/>
					</Col>
				</Row>
				<div className={'btn-group'}>
					<Button type={'ghost'} onClick={back}>Thoát</Button>
					<Button type={'primary'} onClick={handleSubmit}>Cập nhật sản phẩm</Button>
				</div>
			</Form>
		</div>
	);
};

export default Form.create({ name: 'ProductCreate' })(ProductCreate);

